import React from 'react';
import { Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import './DialogContent.scss';

const DialogContent = ({
    title,
    header,
    children,
    confirmButton: {
        label: confirmLabel = 'Confirm',
        onClick: onConfirm,
        disabled: confirmDisabled = false
    },
    cancelButton: {
        label: cancelLabel = 'Cancel',
        onClick: onCancel
    }
}) => (
    <div className="dialog-content">
        <div className="title">
            <div className="check-circle-icon-wrapper">
                <CheckCircleIcon className="check-circle-icon" />
            </div>
            <span className="headline-h-700">{title}</span>
        </div>
        <div className="content">
            {header
                ? <div className="content-header">
                    <span className="text-lg-regular">
                        {header}
                    </span>
                </div>
                : ''
            }
            {children}
        </div>
        <div className="actions">
            <Button
                className="cancel-button"
                onClick={onCancel}
            >
                <span className="text-md-semibold">{cancelLabel}</span>
            </Button>
            <Button
                className="confirm-button"
                onClick={onConfirm}
                disabled={confirmDisabled}
            >
                <span className="text-md-semibold">{confirmLabel}</span>
            </Button>
        </div>
    </div>
);

export default DialogContent;
